// Libraries
import { observable } from "mobx";
import { StoresInstance } from "Custom/Stores";

// Core
import { ModelBase } from "Core/Models/ModelBase";

// Custom
import { DelcoteProductsModel, DelcoteProductsModelDTO } from "./GutterSystemSubModels/DelcoteProducts";
import { PlygeneProductsModel, PlygeneProductsModelDTO } from "./GutterSystemSubModels/PlygeneProducts";
import { validate, ValidationError } from "class-validator";

export class GutterSystemModel extends ModelBase<GutterSystemModel, GutterSystemModelDTO> {
    private delcoteProductsModel: DelcoteProductsModel;
    private plygeneProductsModel: PlygeneProductsModel;

    constructor() {
        super();

        this.delcoteProductsModel = new DelcoteProductsModel();
        this.plygeneProductsModel = new PlygeneProductsModel();

        this.products.push({ title: "Plygene gutterline", value: "id_plygene", guarantee: "Plygene gutterline system" });

        if (StoresInstance.domain.showDelcoteGSOptions === true) {
            this.products.push({ title: "Delcote GS", value: "id_delcotegs", guarantee: "Delcote GS gutter coating system" });
        }

        this.productSelection = this.products[0];
    }

    // #region Model Properties

    public get DelcoteProducts(): DelcoteProductsModel {
        return this.delcoteProductsModel;
    }

    public get PlygeneProducts(): PlygeneProductsModel {
        return this.plygeneProductsModel;
    }

    @observable
    public products = observable<any>([]);

    @observable
    public productSelection: any = undefined;

    // #region Model Properties

    public fromDto(model: GutterSystemModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): GutterSystemModelDTO {
        return {
            delcoteProducts: this.productSelection.value === "id_delcotegs" ? this.DelcoteProducts.toDto() : undefined,
            plygeneProducts: this.productSelection.value === "id_plygene" ? this.PlygeneProducts.toDto() : undefined,
        };
    }

    public Validate = (): Promise<ValidationError[]> => {
        if (this.productSelection.value === "id_delcotegs") {
            let promise = validate(this.delcoteProductsModel).then((errors) => {
                // errors is an array of validation errors
                let retVal: ValidationError[] = [];
                if (errors.length > 0) {
                    retVal = errors;
                    console.log("validation failed");
                } else {
                    console.log("validation succeed");
                }

                return retVal;
            });

            return promise;
        } else {
            let promise = validate(this.plygeneProductsModel).then((errors) => {
                // errors is an array of validation errors
                let retVal: ValidationError[] = [];
                if (errors.length > 0) {
                    retVal = errors;
                    console.log("validation failed");
                } else {
                    console.log("validation succeed");
                }

                return retVal;
            });

            return promise;
        }
    };
}

export interface GutterSystemModelDTO {
    delcoteProducts?: DelcoteProductsModelDTO;
    plygeneProducts?: PlygeneProductsModelDTO;
}
